
import Partners from "../../../components/indexPageComponents/Partners";
import AdoptedAnimals from "../../../components/indexPageComponents/AdoptedAnimals"
import SlideBestFriend from "../../../components/indexPageComponents/SlideBestFriend/index.jsx"
import History from "../../../components/indexPageComponents/FrontHistory/history"
import NavBar from "../../../components/Layout/NavBar/NavBar";
import Donations from "../../../components/indexPageComponents/frontDonations/frontDonations";
import Footer from "../../../components/Layout/Footer/index.jsx";
import style from "./style.module.css";
import PinnedAnimals from "../../../components/indexPageComponents/PinnedAnimals/index";
import React, {useEffect} from "react";
import axios from "axios";
import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import {Spinner} from "react-bootstrap";
import paws from "../../../images/patinhas6.svg";


const INITIAL_DATA = {
    total: 0,
    current_page: 1,
    last_page: 1,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    prev_page_url: null,
    path: "",
    from: 1,
    to: 1,
    data: [],

};



export default function IndexPage()
{

    const [isLoading, setLoading] = React.useState(true);
    const [pinnedAnimalData, setPinnedAnimalData] = React.useState({ ...INITIAL_DATA });
    const [bannerData, setBannerData] = React.useState({ ...INITIAL_DATA });
    const [pinnedAmount, setPinnedAmount] = React.useState(0);
    const [historyData, setHistoryData] = React.useState({ ...INITIAL_DATA });
    const [bestFriendData, setBestFriendData] = React.useState({ ...INITIAL_DATA });
    const [donationsData, setDonationsData] = React.useState({ ...INITIAL_DATA });
    const [adoptedData, setAdoptedData] = React.useState({ ...INITIAL_DATA });
    const [partnersData, setPartnersData] = React.useState({ ...INITIAL_DATA });
    const [footerData, setFooterData] = React.useState({ ...INITIAL_DATA });
    const [phone, setPhone] = React.useState("");
    let controller = new AbortController();


    let endpoints  = [
        "bannerData",
        "pinnedAmount",
        "dados_animais",
        "dados_historia",
        "animais_naoadotados",
        "donations",
        'animais_adotados',
        "parceiros_todos",
        "information",
        'whatsApp'
    ]

    const requestData = () => {
        axios.all(endpoints.map((endpoint) => BaseApi.get(endpoint, {signal: controller.signal}))).then((response) => {
            setBannerData(response[0].data);
            setPinnedAmount(response[1].data);
            setPinnedAnimalData(response[2].data);
            setHistoryData(response[3].data);
            setBestFriendData(response[4].data);
            setDonationsData(response[5].data);
            setAdoptedData(response[6].data);
            setPartnersData(response[7].data);
            setFooterData(response[8].data);
            setPhone(response[9].data);
        })
            .then((response) => {
                setLoading(false);

            })
            .catch((err) => {
                if (err) {
                    toast.error("Erro ao carregar dados da tabela");
                    setBannerData({ ...INITIAL_DATA })
                    setPinnedAmount(0)
                    setPinnedAnimalData({ ...INITIAL_DATA })
                    setHistoryData({ ...INITIAL_DATA })
                    setBestFriendData({ ...INITIAL_DATA })
                    setDonationsData({ ...INITIAL_DATA })
                    setAdoptedData({ ...INITIAL_DATA })
                    setPartnersData({ ...INITIAL_DATA })
                    setFooterData({ ...INITIAL_DATA })
                    setPhone("")

                }
            });
    };

    const urlLog = () =>{
        const url = window.location.href;
        const tag = url.split("/").pop();
        if (Array.from(tag)[0]==="#"){
          setTimeout(()=>{
            let id = document.getElementById(tag.substring(1))
            if(id!=null){
              id.scrollIntoView()
            }
          }, 1000)

        }

    }

    useEffect(() => {
        controller = new AbortController();
        requestData();
        return () => {
            controller.abort();
            setLoading(true);
        };
    }, [])



    return(
        <>

        <div className={style.Page}>
            <NavBar
            phone={phone}/>

            {isLoading && (
                <>
                    <Spinner animation="border" role="status" className={style.spinner}>
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </>
            )}

            {(!isLoading) && (
              <>

                  {((pinnedAmount>0) || (bannerData.data[3])) && (
                      <PinnedAnimals
                      animalData={pinnedAnimalData}
                      bannerData={bannerData}
                      pinnedAmount={pinnedAmount}/>
                  )}

                <div id="history" className={style.urlJump}>
                  {(historyData) && (
                      <History
                          historyData={historyData}
                      />
                  )}
                </div>

                <div id="bestFriend" className={style.urlJump}>
                  {(bestFriendData.data.length>0) && (
                      <SlideBestFriend
                          animalsData={bestFriendData.data}/>
                  )}
                </div>

                <div id="donation" className={style.urlJump}>
                  {(donationsData.data.length>0) && (
                      <Donations
                      donationsData={donationsData.data}/>
                  )}
                </div>

                <div id="adopted" className={style.urlJump}>
                  {(adoptedData.data.length>0) && (
                      <AdoptedAnimals
                      animal={adoptedData.data}/>
                  )}
                </div>


                <div id="partners" className={style.urlJump}>
                  {(partnersData.data.length>0) && (
                      <Partners
                      partnersData={partnersData.data}/>
                  )}
                </div>

                <div id="footer" className={style.urlJump}>
                  {(footerData)&&(
                      <Footer
                      informationData={footerData}
                      phone={phone}/>

                  )}
                </div>

                  {urlLog()}
              </>
            )}
        </div>

        </>
    )
}